/* eslint-disable jira/filename-case */

// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6
import { createIllustration } from '@jira/illustrations__illustration/src/ui/index.tsx';
import type {
	AsImgProps,
	IllustrationFn,
	SVGViewBox,
} from '@jira/illustrations__illustration/src/ui/types.tsx';
import srcDark from '../../assets/error-darkmode.svg';
import srcLight from '../../assets/error.svg';

const Illustration: IllustrationFn<AsImgProps> = createIllustration({
	srcLight,
	srcDark,
});

export default Illustration;

// for advanced use only
export const viewBox: SVGViewBox = [0, 0, 164, 218];
